export const EMBEDDED_PREVIEW_CLOSE = 'synapse-close-embedded-preview';

export function isEmbeddedPreviewRoute(route) {
  return !!(route && route.query && route.query.embeddedPreview === '1');
}

/** Ask the parent frame (linked preview popup) to close. Returns true if a parent was notified. */
export function requestCloseEmbeddedPreview() {
  if (window.parent && window.parent !== window) {
    window.parent.postMessage({ type: EMBEDDED_PREVIEW_CLOSE }, window.location.origin);
    return true;
  }
  return false;
}

/** Listen for close requests from embedded preview iframes. Returns a cleanup function. */
export function onEmbeddedPreviewCloseRequest(handler) {
  const listener = (event) => {
    if (event.origin !== window.location.origin) return;
    const data = event.data;
    if (data && data.type === EMBEDDED_PREVIEW_CLOSE) {
      handler();
    }
  };
  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
}
